/**
 * Variable width for gallery from Flickity
 */

var $galleryClass = '.js-gallery';

var $flickitygallery = $($galleryClass);
var $flickitycaption = $('.js-gallery-caption');

if ($flickitygallery.find('img').length > 1) {
    $flickitygallery.imagesLoaded(function() {
        $flickitygallery.flickity({
            // options
            cellAlign: 'center',
            prevNextButtons: true,
            //imagesLoaded: true,
            lazyLoad: true,
            pageDots: false,
            wrapAround: true,
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 65,
                y2: 45,
                x3: 20
            },
            on: {
                ready: function() {
                    //console.log('Flickity is ready');
                },
                change: function(index) {
                    //console.log('Slide changed to' + index);

                    var $iframes = $($galleryClass + ' .gallery__slide:not(.is-selected)').find('iframe');

                    $iframes.each(function(index, element) {
                        var $iframe = $(element);

                        if ($iframe.hasClass('youtube')) {
                            if ($iframe.length > 0) {
                                $iframe[0].contentWindow.postMessage(JSON.stringify({
                                    'event': 'command',
                                    'func': 'stopVideo',
                                    'args': []
                                }), "*");
                            }

                        } else if ($iframe.hasClass('vimeo')) {
                            if ($iframe.length > 0) {
                                $iframe[0].contentWindow.postMessage(JSON.stringify({
                                    'method': 'pause'
                                }), "*");
                            }
                        }
                    });

                    setCaption();
                }
            }
        });
    });
}

function setCaption() {
    var activeSlideCaption = $flickitygallery.find('.gallery__slide.is-selected').data('caption');
    if (activeSlideCaption == '') {
        activeSlideCaption = '&nbsp;';
    }
    $flickitycaption.html(activeSlideCaption);
}

setCaption();
